import { windowIsDefined } from '@klv/shared/utils/functions';
import { defaultScrollDistance } from './variables';

import type {
  ICarouselClick, ICarouselCardFocus, IScrollDistanceValue, IUpdateCarouselButton, IUpdateNextButton, TScrollBoxFunction,
} from '../types';

export const getColumnGap = (scrollBox?: TScrollBoxFunction) => (
  windowIsDefined() && scrollBox
    ? parseFloat(window.getComputedStyle(scrollBox).getPropertyValue('column-gap'))
    : defaultScrollDistance
);

export const getGalleryPadding = (scrollBox?: TScrollBoxFunction) => (
  windowIsDefined() && scrollBox
    ? parseFloat(window.getComputedStyle(scrollBox).getPropertyValue('padding-right'))
    : 0
);

export const getScrollBox = (carousel: HTMLElement | null) => (carousel ? carousel.querySelector('div') : null);

export const handleCardFocus = ({ card, galleryPadding = 20, scrollBox }: ICarouselCardFocus) => {
  if (scrollBox && card) {
    scrollBox.scrollTo(card.offsetLeft - galleryPadding, 0);
  }
};

export const handleCarouselClick = ({ carousel, direction, scrollDistance }: ICarouselClick) => {
  if (carousel) {
    carousel.scrollBy(direction === 'previous' ? -scrollDistance.current : scrollDistance.current, 0);
  }
};

export const scrollDistanceValue = ({ cardsRef, columnGap = 0 }: IScrollDistanceValue) => (
  cardsRef?.[1]?.current?.offsetWidth
    ? cardsRef[1].current.offsetWidth + columnGap
    : defaultScrollDistance
);

export const updateShowNext = ({ cardsRef, columnGap, scrollBox }: IUpdateNextButton) => (
  (cardsRef?.[1]?.current?.offsetWidth && scrollBox && (
    (scrollBox.scrollWidth - scrollBox.scrollLeft - cardsRef[1].current.offsetWidth - columnGap) > scrollBox.clientWidth
  ))
  || false
);

export const updateShowPrevious = ({ columnGap, scrollBox }: IUpdateCarouselButton) => (
  (scrollBox && (scrollBox.scrollLeft > (columnGap / 2))) || false
);
